/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_SessionsInputs */

const en_page_title_sessions = /** @type {(inputs: Page_Title_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const nl_page_title_sessions = /** @type {(inputs: Page_Title_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessies`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Page_Title_SessionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_sessions = /** @type {((inputs?: Page_Title_SessionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_SessionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_sessions(inputs)
	return en_page_title_sessions(inputs)
});